var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRelationship(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 38,
    viewBox: "0 0 60 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1638:4498)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M44.3862 28.0781H51.4474",
    stroke: "#78264F",
    strokeWidth: 2.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.8152 36.8695C21.9326 37.0846 21.0031 37.0034 20.1716 36.6392C19.34 36.275 18.653 35.6482 18.2175 34.8557L12.318 24.7949H8.73389",
    stroke: "#78264F",
    strokeWidth: 2.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.5746 26.4492L32.1093 32.7771",
    stroke: "#78264F",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.4661 30.584L25.7567 34.5461",
    stroke: "#78264F",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.674 34.2173C35.6441 34.643 33.6748 35.4534 32.0846 32.752",
    stroke: "#78264F",
    strokeWidth: 2.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.4809 35.9119C29.4809 35.9119 27.3304 37.3773 25.7649 34.5449",
    stroke: "#78264F",
    strokeWidth: 2.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.71741 4.37109H20.3681",
    stroke: "#78264F",
    strokeWidth: 2.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.065916 1.02344H8.48668V28.4879H0",
    stroke: "#78264F",
    strokeWidth: 2.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.9341 3.38867H51.5133V30.8531H60",
    stroke: "#78264F",
    strokeWidth: 2.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.0865 29.1833L35.5617 11.1739C34.7377 11.1248 30.618 10.7558 30.618 10.7558L24.9986 16.4293C20.3021 19.9984 17.7397 14.7425 17.7397 14.7425L24.9575 5.38602C27.3799 2.36534 29.8187 2.32422 29.8187 2.32422H40.6949L51.3485 6.93291",
    stroke: "#78264F",
    strokeWidth: 2.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.7127 28.4644C45.276 29.6759 42.5076 36.7729 38.9316 30.5597L33.9879 22.7988",
    stroke: "#78264F",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.797 23.9766C58.797 24.1029 58.7593 24.2266 58.6887 24.3316C58.6181 24.4366 58.5177 24.5183 58.4003 24.5666C58.2828 24.6149 58.1536 24.6272 58.029 24.6026C57.9043 24.5779 57.7898 24.5176 57.6999 24.4283C57.61 24.339 57.5488 24.2252 57.524 24.1013C57.4992 23.9775 57.5119 23.8487 57.5606 23.732C57.6092 23.6153 57.6916 23.516 57.7973 23.4458C57.903 23.3757 58.0272 23.3379 58.1543 23.3379C58.3248 23.3379 58.4882 23.4052 58.6088 23.525C58.7293 23.6447 58.797 23.8073 58.797 23.9766Z",
    fill: "#78264F",
    stroke: "#78264F",
    strokeWidth: 2.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.4718 21.5216C2.4718 21.6478 2.4341 21.7715 2.36348 21.8765C2.29286 21.9815 2.1925 22.0632 2.07507 22.1115C1.95763 22.1599 1.82839 22.1721 1.70373 22.1475C1.57906 22.1229 1.46456 22.0625 1.37468 21.9732C1.2848 21.8839 1.22361 21.7701 1.19881 21.6463C1.17402 21.5224 1.18673 21.3936 1.23538 21.2769C1.28402 21.1603 1.3664 21.0609 1.47209 20.9907C1.57778 20.9206 1.70204 20.8828 1.82915 20.8828C1.9996 20.8828 2.16304 20.9501 2.28357 21.0699C2.40409 21.1896 2.4718 21.3522 2.4718 21.5216Z",
    fill: "#78264F",
    stroke: "#78264F",
    strokeWidth: 2.5,
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1638:4498"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 38,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRelationship);
export default __webpack_public_path__ + "static/media/relationship.97768473.svg";
export { ForwardRef as ReactComponent };